// Third-party
import React from 'react';

interface Props {
  label: React.ReactNode;
  value: React.ReactNode;
}

const RiskProfileRuleTarget = ({ value, label }: Props) => (
  <div className="rule-value-container">
    <span className="rule-value">{value}</span>
    <span className="rule-label">{label}</span>
  </div>
);

export default RiskProfileRuleTarget;
